import {
  Paper,
  Autocomplete,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TableContainer,
  Typography,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableFooter,
  TableCell,
  TableBody,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { fetchInvoiceCustomer } from "../../../../redux/actions/InvoicesActions";
import { InvoiceCustomerAddPopUpModal } from "./InvoiceCustomerAddPopUpModal";
import {
  validateAddInvoices,
  validateInvoiceLine,
} from "../../../../utils/validation";
import { addInvoices } from "../../../../redux/actions/InvoicesActions";
import useAlert from "../../../../hooks/useAlert";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";

export const InvoiceAddPopUpModal = ({ openDialog, handleCloseDialog }) => {
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const dispatch = useDispatch();

  const { invoicesCustomer } = useSelector((state) => state?.invoicesCustomer);
  useEffect(() => {
    dispatch(fetchInvoiceCustomer(authUserId));
    const currentDate = new Date();
    currentDate.setHours(currentDate.getHours() + 3);
    const currentDateTime = currentDate.toISOString().slice(0, 16);

    setInvoiceValue((prevState) => ({
      ...prevState,
      issueDate: currentDateTime,
    }));
  }, []);

  const [invoiceValue, setInvoiceValue] = useState({
    issueDate: "",
    paymentMeansCode: 4,
    number: "",
    orderNumber: "",
    type: "",
    currencyCode: "",
    status: "1",
    paymentDueDate: "",
    note: "",
    customerData: "",
    recordType: "",
  });
  const { showSuccessAddInvoices, showErrorAlertAddInvoices } = useAlert();
  const [formErrors, setFormErrors] = useState({
    issueDate: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInvoiceValue((prevUserValue) => ({
      ...prevUserValue,
      [name]: value,
    }));
    setFormErrors({ ...formErrors, [name]: "" });
  };
  const handleInputChangeUser = (event, value) => {
    setInvoiceValue((prevState) => ({
      ...prevState,
      customerData: value,
    }));
  };

  const addInvoice = async (e) => {
    e.preventDefault();
    //fatura detayları
    invoiceValue.invoiceLines = lineItems;
    //faturanın kesildiği müşteri
    invoiceValue.userOfCustomerId = invoiceValue.customerData.id;
    //fatura oluşturan kişi
    invoiceValue.userId = authUserId;
    //manuel fatura olduğunu belirtiyorum
    invoiceValue.invoiceRecordType = 1;
    invoiceValue.totalAmount = lineItems.reduce(
      (total, item) => total + item.lineExtensionAmount,
      0
    );

    setFormErrors({});
    const invoiceErrors = validateAddInvoices(invoiceValue);
    const lineErrors = validateInvoiceLine(invoiceValue);
    const combinedErrors = {
      ...invoiceErrors,
      ...lineErrors,
    };
    setFormErrors(combinedErrors);
    if (
      Object.keys(invoiceErrors).length === 0 &&
      Object.keys(lineErrors).length === 0
    ) {
      try {
        await dispatch(addInvoices(invoiceValue));
        handleCloseDialog();
        showSuccessAddInvoices();
      } catch (err) {
        showErrorAlertAddInvoices();
        console.error("ınvoice add failed:", err);
      }
    }
  };
  const [openDialogCustomer, setOpenDialogCustomer] = useState(false);
  const handleOpenModal = () => {
    setOpenDialogCustomer(true);
  };

  const [totals, setTotals] = useState({
    totalSubtotal: 0,
    totalDiscountAmount: 0,
    totalDiscountedAmount: 0,
    totalVatAmount: 0,
    totalLineExtensionAmount: 0,
  });

  const [lineItems, setLineItems] = useState([
    {
      unitCode: "",
      inventoryCard: "",
      quantity: "",
      price: "",
      vatRate: 0,
      discountRate: 0,
      discountAmount: "",
      vatIncluded: true,
      lineExtensionAmount: 0,
      discountAmount: 0,
      vatAmount: 0,
      discountedAmount: 0,
      subtotal: 0,
      unit: "Adet",
      description: "",
    },
  ]);

  const handleLineItemChange = (index, field, value) => {
    const newLineItems = [...lineItems];
    newLineItems[index][field] = value;

    if (
      field === "quantity" ||
      field === "price" ||
      field === "vatRate" ||
      field === "discountRate" ||
      field === "vatIncluded"
    ) {
      const item = newLineItems[index];
      const subtotal = item.quantity * item.price; // miktar * birim fiyatı
      const discountAmount = subtotal * (item.discountRate / 100); // iskonto tutarı
      const discountedAmount = subtotal - discountAmount; //iskonto sonrası tutar
      const vatAmount = (discountedAmount * item.vatRate) / 100; // kdv hesaplama
      item.discountedAmount = discountedAmount;
      item.subtotal = subtotal;
      item.vatAmount = vatAmount;
      item.discountAmount = discountAmount;

      let lineExtensionAmount;
      if (item.vatIncluded) {
        const vatAmount = (subtotal - discountAmount) * (item.vatRate / 100);
        lineExtensionAmount = subtotal - discountAmount + vatAmount;
        item.vatAmount = 0; // KDV dahil ise KDV'yi sıfırla
      } else {
        lineExtensionAmount = subtotal - discountAmount;
      }

      item.lineExtensionAmount = lineExtensionAmount;
    }

    // Toplamları hesapla
    let totalSubtotal = 0;
    let totalDiscountAmount = 0;
    let totalDiscountedAmount = 0;
    let totalVatAmount = 0;
    let totalLineExtensionAmount = 0;

    newLineItems.forEach((item) => {
      totalSubtotal += item.subtotal || 0;
      totalDiscountAmount += item.discountAmount || 0;
      totalDiscountedAmount += item.discountedAmount || 0;
      totalVatAmount += item.vatAmount || 0;
      totalLineExtensionAmount += item.lineExtensionAmount || 0;
    });
    setLineItems(newLineItems);
    setTotals({
      totalSubtotal,
      totalDiscountAmount,
      totalDiscountedAmount,
      totalVatAmount,
      totalLineExtensionAmount,
    });
  };

  const addLineItem = () => {
    setLineItems([
      ...lineItems,
      {
        unitCode: "",
        inventoryCard: "",
        quantity: "",
        price: "",
        vatRate: 0,
        discountRate: 0,
        discountAmount: "",
        vatIncluded: true,
        lineExtensionAmount: 0,
        discountAmount: 0,
        vatAmount: 0,
        discountedQuantity: 0,
        taxablAamount: 0,
        subtotal: 0,
        discountedAmount: 0,
        unit: "Adet",
        description: "",
      },
    ]);
  };

  //Satır sildikten sonra tekrar toplamları hesaplayabilmek için tanımlıyoruz
  const calculateTotals = (items) => {
    let totalSubtotal = 0;
    let totalDiscountAmount = 0;
    let totalDiscountedAmount = 0;
    let totalVatAmount = 0;
    let totalLineExtensionAmount = 0;

    items.forEach((item) => {
      totalSubtotal += item.subtotal || 0;
      totalDiscountAmount += item.discountAmount || 0;
      totalDiscountedAmount += item.discountedAmount || 0;
      totalVatAmount += item.vatAmount || 0;
      totalLineExtensionAmount += item.lineExtensionAmount || 0;
    });

    setTotals({
      totalSubtotal,
      totalDiscountAmount,
      totalDiscountedAmount,
      totalVatAmount,
      totalLineExtensionAmount,
    });
  };
  //////////////////////////////////////////////////////////////////
  const removeLineItem = (index) => {
    const newLineItems = lineItems.filter((_, i) => i !== index);
    setLineItems(newLineItems);
    calculateTotals(newLineItems);
  };
  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle
        sx={{
          color: "black",
          fontWeight: "bold",
          textAlign: "center",
          padding: { xs: 1, sm: 2 },
        }}
      >
        Fatura Ekle
      </DialogTitle>
      <DialogContent sx={{ p: { xs: 1, sm: 2 } }}>
        <Grid container spacing={{ xs: 1, sm: 2 }}>
          <Grid item xs={12} md={10} sx={{ marginTop: { xs: 0, sm: 1 } }}>
            <Autocomplete
              fullWidth
              options={invoicesCustomer}
              getOptionLabel={(option) => option.name}
              onChange={handleInputChangeUser}
              renderInput={(params) => (
                <TextField
                  size="small"
                  {...params}
                  label="Müşteri"
                  variant="outlined"
                  error={!!formErrors.customerData}
                  helperText={formErrors.customerData}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Button
              sx={{
                height: { xs: "40px", sm: "56px" },
                borderRadius: 18,
                backgroundColor: "#1F1B45",
                color: "#FFFFFF",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "5px 10px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#2C285A",
                },
              }}
              variant="contained"
              startIcon={<AddIcon />}
              size="large"
              onClick={handleOpenModal}
            >
              Yeni müşteri ekle
            </Button>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              name="issueDate"
              value={invoiceValue.issueDate}
              onChange={handleInputChange}
              fullWidth
              label="Düzenlenme Tarihi ve Saati"
              variant="outlined"
              type="datetime-local"
              InputLabelProps={{
                shrink: true,
              }}
              error={!!formErrors.issueDate}
              helperText={formErrors.issueDate}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Ödeme Yöntemi</InputLabel>
              <Select
                name="paymentMeansCode"
                label="Ödeme Yöntemi"
                value={invoiceValue.paymentMeansCode}
                onChange={handleInputChange}
                defaultValue="4"
                error={!!formErrors.paymentMeansCode}
                helperText={formErrors.paymentMeansCode}
              >
                <MenuItem value="1">Ödeme Aracısı</MenuItem>
                <MenuItem value="2">Kapıda Ödeme</MenuItem>
                <MenuItem value="3">EFT/Havale</MenuItem>
                <MenuItem value="4">Kredi Kartı/Banka Kartı</MenuItem>
                <MenuItem value="5">Diğer</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              size="small"
              error={!!formErrors.number}
              helperText={formErrors.number}
              fullWidth
              name="number"
              value={invoiceValue.number}
              onChange={handleInputChange}
              label="Fatura No"
              variant="outlined"
              placeholder="Fatura No"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              size="small"
              error={!!formErrors.orderNumber}
              helperText={formErrors.orderNumber}
              fullWidth
              name="orderNumber"
              value={invoiceValue.orderNumber}
              onChange={handleInputChange}
              label="Sipariş No"
              variant="outlined"
              placeholder="Sipariş No"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Fatura Türü</InputLabel>
              <Select
                error={!!formErrors.type}
                helperText={formErrors.type}
                name="type"
                label="Fatura türü"
                value={invoiceValue.type}
                onChange={handleInputChange}
                defaultValue=""
              >
                <MenuItem value="1">Satış</MenuItem>
                <MenuItem value="2">İade</MenuItem>
                <MenuItem value="3">İstisna</MenuItem>
                <MenuItem value="4">Özel Matrah</MenuItem>
                <MenuItem value="5">Tevkiyat</MenuItem>
                <MenuItem value="6">İhracat kayıtı</MenuItem>
                <MenuItem value="7">SGK</MenuItem>
                <MenuItem value="8">Komisyoncu</MenuItem>
                <MenuItem value="9">Hal tipi satış</MenuItem>
                <MenuItem value="10">Hal Tipi Komisyoncu</MenuItem>
                <MenuItem value="11">Teckiyat iade Faturası</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Para Birimi</InputLabel>
              <Select
                error={!!formErrors.currencyCode}
                helperText={formErrors.currencyCode}
                name="currencyCode"
                label="Para birimi"
                value={invoiceValue.currencyCode}
                onChange={handleInputChange}
                defaultValue=""
              >
                <MenuItem value="TL">Türk Lirası (TL)</MenuItem>
                <MenuItem value="USD">Amerikan Doları (USD)</MenuItem>
                <MenuItem value="EUR">Euro (EUR)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Durum</InputLabel>
              <Select
                error={!!formErrors.status}
                helperText={formErrors.status}
                name="status"
                label="Durum"
                value={invoiceValue.status}
                onChange={handleInputChange}
                defaultValue=""
              >
                <MenuItem value="1">Taslak</MenuItem>
                <MenuItem value="2">Imzali</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              size="small"
              fullWidth
              error={!!formErrors.paymentDueDate}
              helperText={formErrors.paymentDueDate}
              name="paymentDueDate"
              value={invoiceValue.paymentDueDate}
              onChange={handleInputChange}
              label="Ödeme vade tarihi"
              variant="outlined"
              type="datetime-local"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Fatura kayıt tipi</InputLabel>
              <Select
                error={!!formErrors.recordType}
                helperText={formErrors.recordType}
                name="recordType"
                label="Fatura kayıt tipi"
                value={invoiceValue.recordType}
                onChange={handleInputChange}
                defaultValue=""
              >
                <MenuItem value="1">E-Arşiv</MenuItem>
                <MenuItem value="2">E-Fatura</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              name="note"
              error={!!formErrors.note}
              helperText={formErrors.note}
              value={invoiceValue.note}
              onChange={handleInputChange}
              label="Açıklama"
              variant="outlined"
              placeholder="Hareketle ilgili açıklama..."
              multiline
              rows={3}
            />
          </Grid>
          <TableContainer
            component={Paper}
            sx={{
              mt: { xs: 1, sm: 2 },
              ml: { xs: 0, sm: 2 },
              overflowX: "auto",
              "& .MuiTable-root": {
                minWidth: 1200, // Minimum table width
              },
            }}
          >
            <Table size="small">
              <TableHead>
                <TableRow sx={{ background: "lightgrey" }}>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    Mal/Hizmet
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>Stok Kodu</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>Miktar</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    Birim Fiyat
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>KDV %</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>İskonto %</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    Kalem Açıklaması
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    Kdv dahil mi?
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>Tutar</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>İskonto</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>KDV</TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    İndirimli Tutar
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    Vergili Tutar
                  </TableCell>
                  <TableCell sx={{ whiteSpace: "nowrap" }}>
                    Ödenecek Tutar
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody sx={{}}>
                {lineItems?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {/* Mal/Hizmet */}
                      <TextField
                        size="small"
                        InputProps={{
                          style: {
                            width: 110,
                            height: 35,
                          },
                        }}
                        fullWidth
                        value={item.inventoryCard}
                        error={!!formErrors[index]?.inventoryCard}
                        helperText={formErrors[index]?.inventoryCard}
                        onChange={(e) =>
                          handleLineItemChange(
                            index,
                            "inventoryCard",
                            e.target.value
                          )
                        }
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        size="small"
                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        fullWidth
                        value={item.unitCode}
                        onChange={(e) =>
                          handleLineItemChange(
                            index,
                            "unitCode",
                            e.target.value
                          )
                        }
                        error={!!formErrors[index]?.unitCode}
                        helperText={formErrors[index]?.unitCode}
                      />
                    </TableCell>
                    <TableCell>
                      {/*Miktar*/}
                      <TextField
                        size="small"
                        fullWidth
                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        type="number"
                        value={item.quantity}
                        error={!!formErrors[index]?.quantity}
                        helperText={formErrors[index]?.quantity}
                        onChange={(e) =>
                          handleLineItemChange(
                            index,
                            "quantity",
                            parseInt(e.target.value) || 0
                          )
                        }
                      />
                    </TableCell>

                    <TableCell>
                      {/*Birim Fiyat*/}
                      <TextField
                        size="small"
                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        type="number"
                        value={item.price}
                        error={!!formErrors[index]?.price}
                        helperText={formErrors[index]?.price}
                        onChange={(e) =>
                          handleLineItemChange(
                            index,
                            "price",
                            parseFloat(e.target.value) || 0
                          )
                        }
                      />
                    </TableCell>

                    <TableCell>
                      {/*Kdv %*/}
                      <TextField
                        size="small"
                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        type="number"
                        value={item.vatRate}
                        error={!!formErrors[index]?.vatRate}
                        helperText={formErrors[index]?.vatRate}
                        onChange={(e) =>
                          handleLineItemChange(
                            index,
                            "vatRate",
                            parseInt(e.target.value) || 0
                          )
                        }
                      />
                    </TableCell>

                    <TableCell>
                      {/*İskonto*/}
                      <TextField
                        size="small"
                        InputProps={{
                          style: { width: 70, height: 40 },
                        }}
                        type="number"
                        value={item.discountRate}
                        error={!!formErrors[index]?.discountRate}
                        helperText={formErrors[index]?.discountRate}
                        onChange={(e) =>
                          handleLineItemChange(
                            index,
                            "discountRate",
                            parseInt(e.target.value) || 0
                          )
                        }
                      />
                    </TableCell>

                    <TableCell>
                      {/*Kalem açıklaması*/}
                      <TextField
                        size="small"
                        InputProps={{
                          style: {
                            width: 110,
                            height: 35,
                          },
                        }}
                        fullWidth
                        value={item.description}
                        error={!!formErrors[index]?.description}
                        helperText={formErrors[index]?.description}
                        onChange={(e) =>
                          handleLineItemChange(
                            index,
                            "description",
                            e.target.value
                          )
                        }
                      />
                    </TableCell>
                    <TableCell>
                      {/*kdv dahil mi ?*/}
                      <Checkbox
                        checked={item.vatIncluded}
                        onChange={(e) =>
                          handleLineItemChange(
                            index,
                            "vatIncluded",
                            e.target.checked
                          )
                        }
                      />
                    </TableCell>
                    {/*toplam*/}
                    <TableCell>{item.subtotal.toFixed(2)} </TableCell>
                    <TableCell>{item.discountAmount.toFixed(2)}</TableCell>
                    <TableCell>{item.vatAmount.toFixed(2)}</TableCell>
                    <TableCell>{item.discountedAmount.toFixed(2)}</TableCell>
                    <TableCell>{item.lineExtensionAmount.toFixed(2)}</TableCell>
                    <TableCell>{item.lineExtensionAmount.toFixed(2)}</TableCell>
                    <TableCell>
                      <Button
                        onClick={() => removeLineItem(index)}
                        disabled={lineItems.length === 1}
                      >
                        <DeleteIcon size={20} />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button
            startIcon={<AddIcon />}
            onClick={addLineItem}
            sx={{ mt: 1, ml: 2, color: "primary" }}
          >
            Yeni Satır Ekle
          </Button>
          <Grid
            container
            spacing={{ xs: 1, sm: 2 }}
            sx={{ marginTop: { xs: 1, sm: 2 } }}
          >
            <Grid item xs={6} sm={4} md={2}>
              <Paper
                sx={{
                  padding: { xs: 1, sm: 2 },
                  textAlign: "center",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  Toplam Ara Toplam
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  {totals.totalSubtotal.toFixed(2)}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <Paper
                sx={{
                  padding: { xs: 1, sm: 2 },
                  textAlign: "center",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  Toplam İskonto
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  {totals.totalDiscountAmount.toFixed(2)}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <Paper
                sx={{
                  padding: { xs: 1, sm: 2 },
                  textAlign: "center",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  İndirimli Tutar
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  {totals.totalDiscountedAmount.toFixed(2)}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <Paper
                sx={{
                  padding: { xs: 1, sm: 2 },
                  textAlign: "center",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  Toplam KDV
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  {totals.totalVatAmount.toFixed(2)}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <Paper
                sx={{
                  padding: { xs: 1, sm: 2 },
                  textAlign: "center",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  VergiToplamı
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  {totals.totalLineExtensionAmount.toFixed(2)}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={6} sm={4} md={2}>
              <Paper
                sx={{
                  padding: { xs: 1, sm: 2 },
                  textAlign: "center",
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  Ödenecek Tutar
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: { xs: "0.75rem", sm: "1rem" } }}
                >
                  {totals.totalLineExtensionAmount.toFixed(2)}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent="flex-end"
            sx={{ mt: { xs: 2, sm: 4 } }}
          >
            <Button
              sx={{
                borderRadius: 18,
                backgroundColor: "#1F1B45",
                color: "#FFFFFF",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                padding: { xs: "8px 16px", sm: "10px 20px" },
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#2C285A",
                },
              }}
              variant="contained"
              startIcon={<SaveIcon />}
              size="large"
              onClick={addInvoice}
            >
              Kaydet
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      {/* müşteri ekleme modalı */}
      <InvoiceCustomerAddPopUpModal
        openDialog={openDialogCustomer}
        handleCloseDialog={() => setOpenDialogCustomer(false)}
      />
    </Dialog>
  );
};
